<div class="mb-0">
    <div class="modal-header p-4">
        <main-calendar-popup-header [selectedCustomerForNewTerm]="selectedCustomerForNewTerm"></main-calendar-popup-header>
        <button (click)="closeCalendar()" type="button" aria-label="Close" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="mf-calendar-body-popup">
        <main-calendar
            [selectedCustomerForNewTerm]="selectedCustomerForNewTerm"
            [canAddNewTerms]="canAddNewTerms"
            [canOpenTerm]="canOpenTerm"
            [highlightTerm]="highlightTerm"
            [isReschedule]="isReschedule"
            [isCreateFromWaitingQueue]="isCreateFromWaitingQueue"
            [isCase]="isCase"
            [genericData]="genericData"
            [isPopupMode]="true"
            [isGetOnlySlot]="isGetOnlySlot"
            [connectTermWithWorkOrder]="connectTermWithWorkOrder"
            (changedTerm)="onChangeTerm($event)"
            (onClosePopup)="closeCalendarWithEvent($event)"
        ></main-calendar>
    </div>
</div>
